<template>
    <div id="products">
        <div class="box" id="products-container">
            <h1>Produtos</h1>
            <hr>
            <h2 id="products-total" style="display: inline-block"></h2>
            <router-link class="btn-0" to="/" ref="btn-close">Fechar</router-link>
            <hr>
            <div v-if="!list.length && !loading">Nenhum produto encontrado.</div>
            <div v-if="loading">Carregando produtos...</div>
            <ul id="products-ul">
                <li v-for="l in list" :key="l.id">
                    <div>
                        <img :src="'https://ademosrv0033c1dev-store.demoservices011.commerce.oraclepdemos.com/' + l.primaryThumbImageURL" width="100">
                    </div>
                    <div>
                        <ul>
                            <li><h3>{{ l.description }}</h3></li>
                            <li><h3>$ {{ String(l.listPrice.toFixed(2)).replace(".", ",") }}</h3></li>
                            <li><router-link class="btn-1" :to="{ name:'produto', params: {id: l.id } }">Adicionar</router-link></li>
                        </ul>
                    </div>
                </li>
            </ul>
            <br>
            <div id="products-controller">
                <router-link class="btn-0" to="/" ref="btn-close">Fechar</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Produtos",
        computed: {
            ...mapGetters([
                'token', 'logged'
            ])
        },
        data() {
            return {
                loading: false,
                list   : []
            }
        },
        methods: {
            ...mapActions([
                'update'
            ]),
            load() {
                this.loading = true;
                axios.post(this.$url + 'php/produtos.php').then(response => this.loadResponse(response));
            },
            loadResponse(obj) {

                console.log('resultado produtos -> ', obj.data);
                if (obj.data.errorCode)
                {
                    this.$parent.logOut(null);
                    alert(obj.data.message);
                }
                else
                {
                    this.list = obj.data.items;
                }
                
                this.loading = false;
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
    #products
    {
        background-color: rgba(0, 0, 0, .6);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
    }
    h1
    {
        box-sizing: border-box;
        text-align: center;
        padding: 10px 0;
    }
    #products-container
    {
        display: block;
        margin: 150px  auto;
        max-height: 80%;
        max-width: 800px;
        overflow-y: auto;
    }
    ul li
    {
        box-sizing: border-box;
        display: block;
        list-style: none;
        padding: 15px 10px;
    }
    ul li div
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 10px;
        vertical-align: top;
    }
    a
    {
        display: inline-block;
        min-width: 150px;
        width: auto;
    }
</style>